export default {"src":"/_next/static/media/0x90059c32eeeb1a2aa1351a58860d98855f3655ad.9fad63a0.svg","height":648,"width":662,"blurWidth":0,"blurHeight":0};